<template>
  <button class="button" @click="btnclick()">{{btn_txt}}</button>
</template>

<script>
export default {
  name: "Button",
  props: {
    btn_txt: {
      required: true,
      type: String
    }
  },
  methods: {
    btnclick(){
     this.$emit('goBack')
     this.$emit('paymentDetails')
     this.$emit('editProfile')
     this.$emit('saveUserPaymentDetail')
     this.$emit('cancelPaymentDetail')
     this.$emit('buyPaymentButton')
     this.$emit('addNewAddress')
     this.$emit('saveNewAdd')
     this.$emit('giftButton')
    }
  }

};
</script>